import { EventEmitter, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import dxTextBox from 'devextreme/ui/text_box';
import { UserPassword } from 'src/app/pages/settings/user/models/user.model';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-change-password-widget',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  @Input() public Type: string = "";
  @Input() public ID: string = "";
  //event
  @Output() saveDataEvent = new EventEmitter<"">();

  _Type: string = "";
  password = "";
  ConfirmPassword = "";
  OldPassword = "";
  passwordPattern: any = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{12,}$/;
  passwordData: UserPassword;
  popupMsgVisible: boolean = false;
  isEditPopup: boolean = false;
  popupmsg: string = "";
  @ViewChild("UserConfirmPass", { static: false }) dxUserConfirmPass: dxTextBox;
  @ViewChild("UserPassNew", { static: false }) dxUserPassNew: dxTextBox;
  @ViewChild("UserOldPass", { static: false }) dxUserOldPass: dxTextBox;

  constructor(private userService: UserService, private router: Router, private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute) { }

  passwordComparison = () => {
    return this.password;
  };
  checkComparison() {
    return true;
  }

  ngOnInit() {
    this._Type = this.Type;
  }

  onFormSubmit = function (e) {

    if (this.Type == 'ChangePasswordAdmin') {

      this.passwordData = new UserPassword();
      this.passwordData.Action = "ChangePasswordAdmin";
      this.passwordData.OldPassword = "";
      this.passwordData.NewPassword = this.password;
      this.passwordData.UserId = this.ID;
      this.passwordData.Param1 = "";
      this.passwordData.Param2 = "";
      this.userService.UpdatePassword(this.passwordData).subscribe(data => {

        if (data != null) {
          if (data.flag > 0) {
            this.notificationService.success(data.msg);
          } else {
            this.notificationService.error(data.msg);
          }
        }
        else {
          this.notificationService.error("something went wrong. please try again later.");
        }
        this.password = "";
        this.ConfirmPassword = "";
        this.saveDataEvent.emit("");
      }, err => {
        this.notificationService.error(err);

      });

    }
    else if (this.Type == 'ChangePasswordUser') {
      if (this.OldPassword == this.password) {
        this.notificationService.error("Old Password and New Password cannot be same.");
      } else {

        this.passwordData = new UserPassword();
        this.passwordData.Action = "User";
        this.passwordData.OldPassword = this.OldPassword;
        this.passwordData.NewPassword = this.password;
        this.passwordData.UserId = 0;
        this.passwordData.Param1 = "";
        this.passwordData.Param2 = "";
        this.userService.UpdatePassword(this.passwordData).subscribe(data => {
          if (data != null) {
            if (data.flag > 0) {
              this.notificationService.success(data.msg);
              this.dxUserConfirmPass.reset();
              this.dxUserPassNew.reset();
              this.dxUserOldPass.refresh();
            } else {
              this.notificationService.error(data.msg);
            }
          }
          else {
            this.notificationService.error("something went wrong. please try again later.");
          }
          this.saveDataEvent.emit("");


        }, err => {
          this.notificationService.error(err);

        });
      }
    }
    else if (this.Type == 'ChangePasswordForgotPassword') {
      const queryParamsSnapshot = this.activatedRoute.snapshot.queryParams;
      let ForgotId = queryParamsSnapshot['id'];
      if (ForgotId) {
        this.passwordData = new UserPassword();
        this.passwordData.Action = "ForgotPassword";
        this.passwordData.OldPassword = "";
        this.passwordData.NewPassword = this.password;
        this.passwordData.UserId = 0;
        this.passwordData.Param1 = this.ID;
        this.passwordData.Param2 = ForgotId;
        this.userService.UpdatePasswordClient(this.passwordData).subscribe(data => {
          if (data != null) {
            if (data.flag > 0) {
              this.notificationService.success(data.msg);
              this.saveDataEvent.emit("success");
              this.popupMsgVisible = true;
              this.popupmsg = data.msg;

              setTimeout(() => {
                window.open(document.getElementsByTagName('base')[0].href + "/login", "_self");
              }, 4000);  //5s

            } else {
              this.notificationService.error(data.msg);
              this.saveDataEvent.emit("error");
            }
          }
          else {
            this.notificationService.error("something went wrong. please try again later.");
            this.saveDataEvent.emit("error");
          }
          this.password = "";
          this.ConfirmPassword = "";

        });
      }
    }

    e.preventDefault();
  }

}
